<template>
    <div id="page-title">
        <v-layout wrap row>
            <v-flex xs12 text-xs-center class="py-4">
                    <h2 class="section-heading">{{ title }}</h2>
                <hr>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    export default {
        props: ['title']
    }
</script>

<style>
    h2 {
        font-weight: normal;
    }
</style>
